// extracted by mini-css-extract-plugin
export default {"container":"Activation_container__CwMuv","textContainer":"Activation_textContainer__HG8gn","text":"Activation_text__xunuP","cardBig":"Activation_cardBig__Itdtq"};